import { PageRouteBuilder } from "@common/route/page-route-builder";
import { CoachListPageComponent } from "./coach-list-page.component";

export const displayCoachListRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-coach-list-page", CoachListPageComponent)
    .atUrl("/coaches")
    .withTitle("Coach Partners")
    .build();
